import { ExportTableName } from '@aibees/elephant/components/export-table-name';
import { ExportFileStatusCell } from '@aibees/elephant/feature/exports-management-table/components/export-file-status-cell';
import { BrowseSearchExportsRequest, ExportItem } from '@aibees/elephant/hooks';
import { AdvanceTableConfig } from '@aibees/shared/features';
import { fHumanReadableNumber } from '@aibees/shared/utils';
import { CardBodyTotalRecords } from '../../styles';
import { ExportTableAction } from './actions/export-table-action';
import { ExportTableViewRecordsAction } from './actions/export-table-action/export-table-view-records-action';
import * as SX from './sx';

export const config: Omit<
  AdvanceTableConfig<ExportItem, BrowseSearchExportsRequest>,
  'browseApi'
> = {
  columns: [
    {
      id: 'name',
      label: 'Name',
      sortable: 'name.keyword',
      width: 132,
      render: (_, v) => <ExportTableName item={v} />,
    },
    {
      id: 'records',
      label: 'Total Records',
      sortable: 'records',
      width: 100,
      render: (v) => (
        <CardBodyTotalRecords>{fHumanReadableNumber(v)}</CardBodyTotalRecords>
      ),
    },
    {
      id: 'status',
      label: 'Status',
      sortable: 'status',
      width: 122,
      render: (_, v, i) => <ExportFileStatusCell item={v} rowNumber={i} />,
      align: 'center',
    },
  ],
  actions: [ExportTableViewRecordsAction, ExportTableAction],
  filters: [],
  actionsConfig: {
    label: 'Action',
    minWidth: '10%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
  },
  hidePagination: true,
  stickyHeader: true,
  defaultOrderBy: 'modified',
  hideColumnsOnNoData: true,
  emptyProps: {
    emptyIcon: 'export',
    emptyIconWrapperSX: SX.emptyIconWrapper,
    titleSx: { fontSize: 14 },
    iconSize: 28,
  },

  hideResetFilters: true,
  cellSx: { p: 1 },
  bordered: 'solid',
};
